import { useEffect, useState, FC, useRef } from "react";
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from "@/components/YhFormBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useGlobalModel } from "@/model/globalModel";
import { useVrmMaintenanceDetailsModel } from "../vrmBillMaintenanceModel";
import { invoiceModel } from "@/views/invoice/manage/InvoiceModel";
import TextPriviewImage from "@/components/Custom/TextPriviewImage";

const OrderReturnStatus = new Map([
    ["pending_review", "待审核"],
    ["billed", "已开单"],
    ["in_stock", "已入库"],
    ["settled", "已结算"],
]);

export const FormBox: FC<RouterParamType> = () => {
    const formRef = useRef<IYhFormRef>();
    const { imageUrl } = invoiceModel();
    const {
        detailLookForm,
        getDetailOne,
    } = useVrmMaintenanceDetailsModel();

    const { getCiDictByDictNumber, getCiDictByDictCode } = useGlobalModel(() => []);

    const { getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { id } = detailsInfo

    useEffect(() => {
        getDetailOne(id)
    }, [id])

    const title = <>
        <div style={{ marginBottom: '10px', marginLeft: '20px', color: '#333' }}>
            <span style={{ fontSize: '16px', marginRight: '20px' }}>{`工单编号:${detailLookForm.orderCode}`}</span>
            <span style={{ fontSize: '16px', marginRight: '20px' }}>{`客户名称:${detailLookForm.customerName}`}</span>
            <span style={{ fontSize: '16px', marginRight: '20px' }}>{`客户类型:${getCiDictByDictNumber(detailLookForm.customerType)?.title}`}</span>
            <span style={{ fontSize: '16px', marginRight: '20px' }}>{`工单来源:${getCiDictByDictNumber(detailLookForm.orderSource)?.title}`}</span>
            <span style={{ fontSize: '16px', marginRight: '20px' }}>{`车辆牌照:${detailLookForm.customerVehicleCode}`}</span>
            <span style={{ fontSize: '16px', marginRight: '20px' }}>{`状态:${getCiDictByDictCode(detailLookForm.orderStatus)?.title}`}</span>
            {detailLookForm.orderReturnStatus && (
                <span style={{ fontSize: '16px' }}>{`退单状态:${OrderReturnStatus.get(detailLookForm.orderReturnStatus)}`}</span>
            )}
        </div>
    </>
    const baseFormItem: IYhFormItemsBox = {
        title: title,
        style: { padding: "18px 0 0 0", marginBottom: "15px" },
        contentClass: "pr-77",
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '客户名称',
                fieldName: "customerName",
                allowClear: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '车辆牌照',
                fieldName: "customerVehicleCode",
                allowClear: true,
                labelCol: { span: 8 },
                span: 4
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '报修用户',
                fieldName: "repairContactName",
                allowClear: true,
                labelCol: { span: 8 },
                span: 4
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '服务方式',
                fieldName: "serviceMethod",
                allowClear: true,
                labelCol: { span: 8 },
                span: 4
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '故障类型',
                fieldName: "serviceType",
                allowClear: true,
                labelCol: { span: 8 },
                span: 4
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '报修地址',
                fieldName: "repairAddress",
                allowClear: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '行驶里程数',
                fieldName: "customerVehicleMileage",
                allowClear: true,
                labelCol: { span: 8 },
                span: 4
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '救援里程数',
                fieldName: "mileage",
                allowClear: true,
                labelCol: { span: 8 },
                span: 4
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '故障内容',
                fieldName: "faultClassification",
                allowClear: true,
                labelCol: { span: 8 },
                span: 4
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '工单类型',
                fieldName: "orderType",
                allowClear: true,
                labelCol: { span: 8 },
                span: 4
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '故障描述',
                fieldName: "faultDesc",
                allowClear: true,
                labelCol: { span: 2 },
                span: 18
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '所属实体',
                fieldName: "ciBusinessEntityName",
                allowClear: true,
                labelCol: { span: 8 },
                span: 4
            }, (detailLookForm.invoiceNum ?
                {
                    type: FormItemTypeEnum.Button,
                    fieldLabel: <><a style={{ color: 'black' }}>发票号码：</a><TextPriviewImage text={detailLookForm.invoiceNum} previewList={detailLookForm.invoiceMd5?.split(",")} imageUrl={imageUrl} /></>,
                    fieldName: "none",
                    span: 6,
                    labelCol: { offset: 2 },
                } :
                {
                    type: FormItemTypeEnum.Input,
                    fieldLabel: "发票号码",
                    fieldName: "invoiceNum",
                    disable: true,
                    placeholder: "",
                }
            ), {
                type: FormItemTypeEnum.Input,
                fieldLabel: '发票类型',
                fieldName: "invoiceTypeName",
                allowClear: true,
                labelCol: { span: 8 },
                span: 4
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '开票人',
                fieldName: "invoiceOperator",
                allowClear: true,
                labelCol: { span: 8 },
                span: 4
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '发票上传时间',
                fieldName: "invoiceUploadTime",
                allowClear: true,
                labelCol: { span: 10 },
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '预约时间',
                fieldName: "reservationTime",
                allowClear: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '预计到达时间',
                fieldName: "teamEstimatedArrivalTime",
                allowClear: true,
                span: 8
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '预计完工时间',
                fieldName: "teamEstimatedFinishTime",
                allowClear: true,
                span: 8
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '备注',
                fieldName: "remark",
                allowClear: true,
                labelCol: { span: 3 },
                span: 12
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '处理结果',
                fieldName: "processResult",
                allowClear: true,
                span: 10
            }
        ]
    };
    const poFromConfig: IYhFormBox = {
        formRef,
        disabled: true,
        labelCol: { span: 6 },
        labelAlign: "right",
        formValues: detailLookForm,
        boxs: [baseFormItem]
    }


    return (
        <YhFormBox {...poFromConfig} />
    )
}